import * as actionTypes from '../../../actions/actionTypes';
import { updateObject } from '../../../utility.js';

const initialState = {
    job: {
        loading: false,
        error: false,
        created: false,
        updated: false,
        fetched: false,
        deleted: false,
        name_available: true,
        name_checked: false,
        changed_used: false,
        details: {},
        message: false,
        recalculated: false
    },
    detailed_calculation: {
        loading: false,
        error: false,
        fetched: false,
        details: {}
    },
    machine: {
        loading: false,
        error: false,
        fetched: false,
        updated: false,
        details: {}
    },
    calculations: {
        loading: false,
        error: false,
        fetched: false,
        details: []
    },
    export: {
        loading: false,
        error: false,
        fetched: false,
        filename: "",
        filebody: []
    },
};

/* ------------------ Job Create ------------------- */
const calculatorJobCreateStart = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: true, error: false, created: false, details: {} } } );
};

const calculatorJobCreateReset = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: false, created: false, details: {} } });
};

const calculatorJobCreateSuccess = ( state, action ) => {
    return updateObject( state, {
        job : {
            ...state.job,
    	    details: action.details,
            loading: false,
            error: false,
            created: true
        }
    } );
};

const calculatorJobCreateFail = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: action.error } } );
};

/* ----------------- Job Duplicate ------------------ */
const calculatorJobDuplicateCheckStart = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: true, name_available: true, error: false, name_checked: false } } );
};

const calculatorJobDuplicateCheckSuccess = ( state, action ) => {
    return updateObject( state, {
        job: {
            ...state.job,
            name_available: !action.name_duplicate,
            name_checked: true
        }
    } );
};

const calculatorJobDuplicateCheckFail = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: action.error } } );
};

const calculatorJobDuplicateCheckReset = ( state, action ) => {
    return updateObject( state, { job: {...state.job, name_available: true, name_checked: false } } );
};

/* ------------------ Job Fetch ------------------- */
const calculatorJobFetchStart = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: true, error: false, fetched: false, details: {} } } );
};

const calculatorJobFetchReset = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: false, fetched: false, details: {} } } );
};

const calculatorJobFetchSuccess = ( state, action ) => {
    return updateObject( state, {
        job : {
            ...state.job,
            details: action.details,
            loading: false,
            error: false,
            fetched: true
        }
    } );
};

const calculatorJobFetchFail = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: action.error } } );
};

/* ------------------ Job Message ------------------- */
const calculatorJobMessageSet = ( state, action ) => {
    return updateObject( state, { job: {...state.job, message: action.message } } );
};
const calculatorJobMessageReset = ( state, action ) => {
    return updateObject( state, { job: {...state.job, message: false } } );
};

/* ------------------ Job Machine Fetch ------------------- */
const calculatorJobMachineFetchStart = ( state, action ) => {
    return updateObject( state, { machine: {...state.machine, loading: true, error: false, fetched: false, details: {} } } );
};

const calculatorJobMachineFetchReset = ( state, action ) => {
    return updateObject( state, { machine: {...state.machine, loading: false, error: false, fetched: false, details: {} } } );
};

const calculatorJobMachineFetchSuccess = ( state, action ) => {
    return updateObject( state, {
        machine : {
            ...state.machine,
            details: action.details,
            loading: false,
            error: false,
            fetched: true
        }
    } );
};

const calculatorJobMachineFetchFail = ( state, action ) => {
    return updateObject( state, { calculations: {...state.calculations, loading: false, error: action.error } } );
};

/* ------------------ Job Calculations Fetch ------------------- */
const calculatorJobCalculationsFetchStart = ( state, action ) => {
    return updateObject( state, { calculations: {...state.calculations, loading: true, error: false, fetched: false, details: [] } } );
};

const calculatorJobCalculationsFetchReset = ( state, action ) => {
    return updateObject( state, { calculations: {...state.calculations, loading: false, error: false, fetched: false, details: [] } } );
};

const calculatorJobCalculationsFetchSuccess = ( state, action ) => {
    return updateObject( state, {
        calculations : {
            ...state.calculations,
            details: action.details,
            loading: false,
            error: false,
            fetched: true
        }
    } );
};

const calculatorJobCalculationsFetchFail = ( state, action ) => {
    return updateObject( state, { calculations: {...state.calculations, loading: false, error: action.error } } );
};

/* ------------------ Job Export Fetch ------------------- */
const calculatorJobExportFetchStart = ( state, action ) => {
    return updateObject( state, { export: {...state.export, loading: true, error: false, fetched: false, filename: "", filebody: [] } } );
};

const calculatorJobExportFetchReset = ( state, action ) => {
    return updateObject( state, { export: {...state.export, loading: false, error: false, fetched: false, filename: "", filebody: [] } } );
};

const calculatorJobExportFetchSuccess = ( state, action ) => {
    return updateObject( state, {
        export : {
            ...state.export,
            filebody: action.filebody,
            filename: action.filename,
            loading: false,
            error: false,
            fetched: true
        }
    } );
};

const calculatorJobExportFetchFail = ( state, action ) => {
    return updateObject( state, { export: {...state.export, loading: false, error: action.error } } );
};

/* ------------------ Job Update ------------------- */
const calculatorJobUpdateStart = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: false, updated: false } } );
};

const calculatorJobUpdateReset = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: false, updated: false } } );
};

const calculatorJobUpdateSuccess = ( state, action ) => {
    return updateObject( state, {
        job : {
            ...state.job,
            filebody: action.filebody,
            loading: false,
            error: false,
            updated: true
        }
    } );
};

const calculatorJobUpdateFail = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: action.error } } );
};

/* ------------------ Job Machine Update ------------------- */
const calculatorJobMachineUpdateStart = ( state, action ) => {
    return updateObject( state, { machine: {...state.machine, loading: false, error: false, updated: false } } );
};

const calculatorJobMachineUpdateReset = ( state, action ) => {
    return updateObject( state, { machine: {...state.machine, loading: false, error: false, updated: false } } );
};

const calculatorJobMachineUpdateSuccess = ( state, action ) => {
    return updateObject( state, {
        machine : {
            ...state.machine,
            details: {
                ...state.machine.details,
                settings: action.settings
            },
            loading: false,
            error: false,
            updated: true
        }
    } );
};

const calculatorJobMachineUpdateFail = ( state, action ) => {
    return updateObject( state, { machine: {...state.machine, loading: false, error: action.error } } );
};

/* ------------------ Job Delete ------------------- */
const calculatorJobDeleteStart = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: true, error: false, deleted: false }} );
};

const calculatorJobDeleteReset = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: false, deleted: false } } );
};

const calculatorJobDeleteSuccess = ( state, action ) => {
    return updateObject( state, {
        job : {
            ...state.job,
            loading: false,
            error: false,
            deleted: true
        }
    } );
};

const calculatorJobDeleteFail = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: action.error } } );
};

/* ------------------ Job Change Active ------------------- */
const calculatorJobChangeActiveStart = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: true, error: false, changed_used: false }} );
};

const calculatorJobChangeActiveReset = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: false, changed_used: false } } );
};

const calculatorJobChangeActiveSuccess = ( state, action ) => {
    return updateObject( state, {
        job : {
            ...state.job,
            loading: false,
            error: false,
            changed_used: true
        }
    } );
};

const calculatorJobChangeActiveFail = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: action.error } } );
};

/* ------------------ Job Recalculate ------------------- */
const calculatorJobRecalculateStart = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: true, error: false, recalculated: false }} );
};

const calculatorJobRecalculateReset = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: false, recalculated: false } } );
};

const calculatorJobRecalculateSuccess = ( state, action ) => {
    return updateObject( state, {
        job : {
            ...state.job,
            loading: false,
            error: false,
            recalculated: true
        }
    } );
};

const calculatorJobRecalculateFail = ( state, action ) => {
    return updateObject( state, { job: {...state.job, loading: false, error: action.error } } );
};

/* ------------------ Job Detailed Calculation ------------------- */
const calculatorJobDetailedCalculationStart = ( state, action ) => {
    return updateObject( state, { detailed_calculation: {...state.detailed_calculation, loading: true, error: false, fetched: false, detailed_calculation: false }} );
};

const calculatorJobDetailedCalculationReset = ( state, action ) => {
    return updateObject( state, { detailed_calculation: {...state.detailed_calculation, loading: false, error: false, fetched: false, detailed_calculation: false } } );
};

const calculatorJobDetailedCalculationSuccess = ( state, action ) => {
    return updateObject( state, {
        detailed_calculation : {
            ...state.detailed_calculation,
            loading: false,
            error: false,
            fetched: true,
            details: action.details
        }
    } );
};

const calculatorJobDetailedCalculationFail = ( state, action ) => {
    return updateObject( state, { detailed_calculation: {...state.detailed_calculation, loading: false, error: action.error } } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
    	case actionTypes.CALCULATOR_JOB_CREATE_START: return calculatorJobCreateStart( state, action );
    	case actionTypes.CALCULATOR_JOB_CREATE_SUCCESS: return calculatorJobCreateSuccess( state, action );
    	case actionTypes.CALCULATOR_JOB_CREATE_FAIL: return calculatorJobCreateFail( state, action );
        case actionTypes.CALCULATOR_JOB_CREATE_RESET: return calculatorJobCreateReset( state, action );
        case actionTypes.CALCULATOR_JOB_DUPLICATECHECK_START: return calculatorJobDuplicateCheckStart( state, action );
        case actionTypes.CALCULATOR_JOB_DUPLICATECHECK_SUCCESS: return calculatorJobDuplicateCheckSuccess( state, action );
        case actionTypes.CALCULATOR_JOB_DUPLICATECHECK_FAIL: return calculatorJobDuplicateCheckFail( state, action );
        case actionTypes.CALCULATOR_JOB_DUPLICATECHECK_RESET: return calculatorJobDuplicateCheckReset( state, action );
        case actionTypes.CALCULATOR_JOB_FETCH_START: return calculatorJobFetchStart( state, action );
        case actionTypes.CALCULATOR_JOB_FETCH_SUCCESS: return calculatorJobFetchSuccess( state, action );
        case actionTypes.CALCULATOR_JOB_FETCH_FAIL: return calculatorJobFetchFail( state, action );
        case actionTypes.CALCULATOR_JOB_FETCH_RESET: return calculatorJobFetchReset( state, action );
        case actionTypes.CALCULATOR_JOB_MESSAGE_SET: return calculatorJobMessageSet( state, action );
        case actionTypes.CALCULATOR_JOB_MESSAGE_RESET: return calculatorJobMessageReset( state, action );
        case actionTypes.CALCULATOR_JOB_UPDATE_START: return calculatorJobUpdateStart( state, action );
        case actionTypes.CALCULATOR_JOB_UPDATE_SUCCESS: return calculatorJobUpdateSuccess( state, action );
        case actionTypes.CALCULATOR_JOB_UPDATE_FAIL: return calculatorJobUpdateFail( state, action );
        case actionTypes.CALCULATOR_JOB_UPDATE_RESET: return calculatorJobUpdateReset( state, action );
        case actionTypes.CALCULATOR_JOB_MACHINE_UPDATE_START: return calculatorJobMachineUpdateStart( state, action );
        case actionTypes.CALCULATOR_JOB_MACHINE_UPDATE_SUCCESS: return calculatorJobMachineUpdateSuccess( state, action );
        case actionTypes.CALCULATOR_JOB_MACHINE_UPDATE_FAIL: return calculatorJobMachineUpdateFail( state, action );
        case actionTypes.CALCULATOR_JOB_MACHINE_UPDATE_RESET: return calculatorJobMachineUpdateReset( state, action );
        case actionTypes.CALCULATOR_JOB_MACHINE_FETCH_START: return calculatorJobMachineFetchStart( state, action );
        case actionTypes.CALCULATOR_JOB_MACHINE_FETCH_SUCCESS: return calculatorJobMachineFetchSuccess( state, action );
        case actionTypes.CALCULATOR_JOB_MACHINE_FETCH_FAIL: return calculatorJobMachineFetchFail( state, action );
        case actionTypes.CALCULATOR_JOB_MACHINE_FETCH_RESET: return calculatorJobMachineFetchReset( state, action );
        case actionTypes.CALCULATOR_JOB_CALCULATIONS_FETCH_START: return calculatorJobCalculationsFetchStart( state, action );
        case actionTypes.CALCULATOR_JOB_CALCULATIONS_FETCH_SUCCESS: return calculatorJobCalculationsFetchSuccess( state, action );
        case actionTypes.CALCULATOR_JOB_CALCULATIONS_FETCH_FAIL: return calculatorJobCalculationsFetchFail( state, action );
        case actionTypes.CALCULATOR_JOB_CALCULATIONS_FETCH_RESET: return calculatorJobCalculationsFetchReset( state, action );
        case actionTypes.CALCULATOR_JOB_EXPORT_FETCH_START: return calculatorJobExportFetchStart( state, action );
        case actionTypes.CALCULATOR_JOB_EXPORT_FETCH_SUCCESS: return calculatorJobExportFetchSuccess( state, action );
        case actionTypes.CALCULATOR_JOB_EXPORT_FETCH_FAIL: return calculatorJobExportFetchFail( state, action );
        case actionTypes.CALCULATOR_JOB_EXPORT_FETCH_RESET: return calculatorJobExportFetchReset( state, action );
        case actionTypes.CALCULATOR_JOB_DELETE_START: return calculatorJobDeleteStart( state, action );
        case actionTypes.CALCULATOR_JOB_DELETE_SUCCESS: return calculatorJobDeleteSuccess( state, action );
        case actionTypes.CALCULATOR_JOB_DELETE_FAIL: return calculatorJobDeleteFail( state, action );
        case actionTypes.CALCULATOR_JOB_DELETE_RESET: return calculatorJobDeleteReset( state, action );
        case actionTypes.CALCULATOR_JOB_CHANGEACTIVE_START: return calculatorJobChangeActiveStart( state, action );
        case actionTypes.CALCULATOR_JOB_CHANGEACTIVE_SUCCESS: return calculatorJobChangeActiveSuccess( state, action );
        case actionTypes.CALCULATOR_JOB_CHANGEACTIVE_FAIL: return calculatorJobChangeActiveFail( state, action );
        case actionTypes.CALCULATOR_JOB_CHANGEACTIVE_RESET: return calculatorJobChangeActiveReset( state, action );
        case actionTypes.CALCULATOR_JOB_RECALCULATE_START: return calculatorJobRecalculateStart( state, action );
        case actionTypes.CALCULATOR_JOB_RECALCULATE_SUCCESS: return calculatorJobRecalculateSuccess( state, action );
        case actionTypes.CALCULATOR_JOB_RECALCULATE_FAIL: return calculatorJobRecalculateFail( state, action );
        case actionTypes.CALCULATOR_JOB_RECALCULATE_RESET: return calculatorJobRecalculateReset( state, action );
        case actionTypes.CALCULATOR_JOB_DETAILED_CALCULATION_START: return calculatorJobDetailedCalculationStart( state, action );
        case actionTypes.CALCULATOR_JOB_DETAILED_CALCULATION_SUCCESS: return calculatorJobDetailedCalculationSuccess( state, action );
        case actionTypes.CALCULATOR_JOB_DETAILED_CALCULATION_FAIL: return calculatorJobDetailedCalculationFail( state, action );
        case actionTypes.CALCULATOR_JOB_DETAILED_CALCULATION_RESET: return calculatorJobDetailedCalculationReset( state, action );
        default: return state;
    }
};


export default reducer;


// WEBPACK FOOTER //
// ./src/_store/reducers/calculator/jobs/job.js